


<template lang="jade">

	div.contact(
		v-if="$route.name !== 'trailer'"
	)

		div.desktop

			div
				span WARDFOUR FILMS &nbsp;&nbsp;
				span NYC &mdash; LA &nbsp;&nbsp;
				a(href="tel:2123750770") 212-375-0770

			div
				span.small EXECUTIVE PRODUCER
				span DICKEY ABEDON:&nbsp;
				a(href="mailto:da@wardfour.com") DA@WARDFOUR.COM
				span &nbsp;&nbsp;&nbsp;
				span.small EXECUTIVE PRODUCER
				span DAN SBREGA:&nbsp;
				a(href="mailto:ds@wardfour.com") DS@WARDFOUR.COM

		div.mobile

			div.mobile-phone
				span WARDFOUR FILMS &nbsp;&nbsp;
				span NYC &mdash; LA &nbsp;&nbsp;
				a(href="tel:2123750770") 212-375-0770

			div
				div.small EXECUTIVE PRODUCERS
				div
					span DICKEY ABEDON:&nbsp;
					a(href="mailto:da@wardfour.com") DA@WARDFOUR.COM
				div
					span DAN SBREGA:&nbsp;
					a(href="mailto:ds@wardfour.com") DS@WARDFOUR.COM

</template>



<script>



	const $cmp = {
		name : 'contact',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.mounted = function() {
		var $this = this
	}



	$cmp.methods = {}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.contact
		position absolute
		bottom 35px
		width 100%
		color #FFFFFF
		line-height 140%
		letter-spacing 1px
		text-align center
		z-index 4

		@media(max-width 1023px)
			bottom 0px
			height 100px

	.desktop
		display block

		div
			margin-bottom 10px

		@media(max-width 1023px)
			display none

	.mobile
		padding-top 10px
		font-size 12px
		display none

		div
			margin-bottom 0px

		@media(max-width 1023px)
			display block

	.mobile-phone
		margin-bottom 10px !important

	.small
		font-size 10px
		padding-right 5px

	a
		color #FFFFFF
		padding-bottom 2px

	a:hover
		border-bottom 1px solid #FFFFFF

</style>



// WEBPACK FOOTER //
// src/components/home/contact.vue